import { v4 as makeUuid } from 'uuid'
import { AxiosInstance } from 'axios'
import { IUrlUtils } from 'v2/modules/lib'

export interface IDomainServiceArgs {
  httpClient: AxiosInstance
  urlUtils: IUrlUtils
}

export const makeDomainService = ({ httpClient, urlUtils }: IDomainServiceArgs) => {
  const getDomainSettings = async (domainId: number, variables: string[]): Promise<Array<Record<string, any>>> => {
    const res = await httpClient.get(`/domain-service/domain/${urlUtils.urlEncode(domainId)}/settings`, {
      params: {
        variables: variables.join(',')
      },
      headers: {
        'X-Request-ID': makeUuid()
      }
    })
    return res.data
  }

  const saveDomainSettings = async (domainId: number, settings: Array<Record<string, any>>) => {
    const res = await httpClient.put(`/domain-service/domain/${urlUtils.urlEncode(domainId)}/settings`, settings, {
      headers: {
        'X-Request-ID': makeUuid()
      }
    })
    return res.data
  }

  const getDomainQnsSettings = async (domainId: number, effective = false): Promise<Record<string, any>> => {
    const res = await httpClient.get(`/domain-service/domain/${urlUtils.urlEncode(domainId)}/qns-settings`, {
      params: {
        effective: effective ? 'true' : 'false'
      },
      headers: {
        'X-Request-ID': makeUuid()
      }
    })
    return res.data
  }

  const saveDomainQnsSettings = async (domainId: number, settings: Record<string, any>) => {
    const res = await httpClient.put(`/domain-service/domain/${urlUtils.urlEncode(domainId)}/qns-settings`, settings, {
      headers: {
        'X-Request-ID': makeUuid()
      }
    })
    return res.data
  }

  return Object.freeze({
    getDomainSettings,
    saveDomainSettings,
    getDomainQnsSettings,
    saveDomainQnsSettings
  })
}
